module.exports = __webpack_public_path__ + "img/ewm.6bf37fde.jpg";